module.exports = __webpack_public_path__ + "static/medograf-extraimg3@2x-min-13012e419405602202460e57eef3c8a0.png";